import { render, staticRenderFns } from "./RemnantPastRecord.vue?vue&type=template&id=68a1fd62"
import script from "./RemnantPastRecord.vue?vue&type=script&lang=js"
export * from "./RemnantPastRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports